module.exports = __webpack_public_path__ + "Sample-Import-Payment-Gateway-Dipay.xlsx";